import React from 'react';
import ChatComponent from '../admin/ChatComponent';



const UserChatComponent = () => {
  const adminId = 'DeWlV1Sz9OPikjJieVNDkbt2uur1'; 

  return (
    <div className='user-chat-component'> 
    <ChatComponent receiverId={adminId} isAdmin={false} />
    <p>Chat with an Admin to Order</p> 
    </div>
    );
};
  

export default UserChatComponent;
